import script from "./ServiceResponseViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceResponseViewer.vue?vue&type=script&setup=true&lang=js"

import "./ServiceResponseViewer.vue?vue&type=style&index=0&id=2ca5daaf&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ca5daaf"]])

export default __exports__